import { SvgPorterLogo } from '@kiper/ui';
import { useTheme } from 'styled-components';
import * as S from './styles';

const LoadingPage = () => {
  const theme = useTheme();

  return (
    <S.LoadingPageWrapper>
      <S.SpinnerContainer>
        <S.Spinner />
      </S.SpinnerContainer>

      <S.Footer>
        <S.PoweredByText>powered by</S.PoweredByText>
        <SvgPorterLogo size={100} color={theme.colors.porterPrimary} />
      </S.Footer>
    </S.LoadingPageWrapper>
  );
};

export default LoadingPage;
